import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EventsModel } from './events.model';

@Injectable({
  providedIn: 'root'
})

export class DataArrayService {
  private dataArray: EventsModel = {
    id: '',
    name: '',
    price: null,
    amount: null,
    minTickets: null,
    maxTickets: null,
    maxPerUser: null,
    description: '',
    location: '',
    iniDate: '',
    endDate: '',
    iniSale: '',
    endSale: '',
    imageUrl: '',
    isNominative: false,
    formData: [],
    categories: null

  };
  private dataArraySubject = new BehaviorSubject<EventsModel>(this.dataArray);

  dataArray$ = this.dataArraySubject.asObservable();
  data: any;


  addData(data: EventsModel) {
    this.dataArray = data;
    this.dataArraySubject.next(this.dataArray);
  }

  getDataArray(): EventsModel {
    return this.dataArray;
  }

  setData(value: any) {
    this.data = value;
  }

  getData() {
    return this.data;
  }

  event_clicked: EventsModel = {
    id: '',
    name: '',
    price: null,
    amount: null,
    minTickets: null,
    maxTickets: null,
    maxPerUser: null,
    description: '',
    location: '',
    iniDate: '',
    endDate: '',
    iniSale: '',
    endSale: '',
    imageUrl: '',
    isNominative: false,
    formData: [],
    categories: null
  };

  setEventClicked(event: EventsModel) {
    this.event_clicked.id = event.id;
    this.event_clicked.name = event.name;
    this.event_clicked.price = event.price;
    this.event_clicked.amount = event.amount;
    this.event_clicked.minTickets = event.minTickets;
    this.event_clicked.maxTickets = event.maxTickets;
    this.event_clicked.maxPerUser = event.maxPerUser;
    this.event_clicked.description = event.description || '';
    this.event_clicked.location = event.location || '';
    this.event_clicked.iniDate = event.iniDate || '';
    this.event_clicked.endDate = event.endDate || '';
    this.event_clicked.iniSale = event.iniSale || '';
    this.event_clicked.endSale = event.endSale || '';
    this.event_clicked.imageUrl = event.imageUrl || '';
    this.event_clicked.isNominative = event.isNominative || false;
    this.event_clicked.formData = event.formData || [];
    this.event_clicked.categories = event.categories || null;
  }

  getEventClicked() {
    return this.event_clicked;
  }


  delete_event_state = "";


  setDeleteEventState(flag: boolean) {
    if (flag === true) {
      this.delete_event_state = "borrar_evento";
    } else {
      this.delete_event_state = "actualizar_evento";
    }

  }

}
